export default {
    list_agents: 'Buscar por Nombre o E-mail',
    list_customers: 'Buscar por Nombre, E-mail u Organización',
    list_calls: 'Buscar por Número o Título',
    list_tasks: 'Buscar por número, título o descripción',
    list_attendance_groups: 'Buscar por Nombre u Organización',
    list_sla_config: 'Buscar por Grupo de Servicio o Categoría',
    list_organizations: 'Buscar por Nombre, Sitio Web o Teléfono',
    by_name_or_description: 'Buscar por Nombre o Descripción',
    by_description: 'Buscar por Descripción',
    by_name: 'Buscar por Nombre',
    by_title_or_content: 'Buscar por Título o contenido',
}
